import { Component, Input, NgModule } from '@angular/core';
import { Employee } from '../../../models/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePageService } from '../../services/profile-page.service';

@Component({
  selector: 'app-update-employee-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './update-employee-modal.component.html',
  styleUrl: './update-employee-modal.component.scss'
})
export class UpdateEmployeeModalComponent {
  @Input() employee!: Employee;

  constructor(
    public activeModal: NgbActiveModal,
    private profilePageService: ProfilePageService
  ) {}

  save() {
    console.log('Updating employee:', this.employee);
    this.profilePageService.updateEmployee(this.employee!)
    .subscribe(
      (response) => {
        console.log('Employee updated successfully:', response);
        this.activeModal.close(); // Close the modal after successful update
      },
      (error) => {
        console.error('Error updating employee:', error);
        // Handle error
      }
    );
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
